import React from 'react'

interface StatCardItem {
  icon: string
  label: string
  value: string
}

interface StatCardsProps {
  stats: StatCardItem[]
  style?: React.CSSProperties
}

export const StatCards: React.FC<StatCardsProps> = ({ stats, style }) => (
  <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', ...style }}>
    {stats.map(stat => (
      <div key={stat.label} style={{ flex: '1 1 110px', background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 10, padding: '0.75rem 1rem', textAlign: 'center' }}>
        <div style={{ fontSize: '1.1rem' }}>{stat.icon}</div>
        <div style={{ fontWeight: 700, fontSize: '1rem', color: 'var(--text-primary)', marginTop: '0.2rem' }}>{stat.value}</div>
        <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)', marginTop: '0.1rem' }}>{stat.label}</div>
      </div>
    ))}
  </div>
)
